import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import type { ExperimentalFavouriteSpaceType } from '../__types__/ExperimentalSchema';

export const experimentalFavouriteSpace: ExperimentalMutations['experimentalFavouriteSpace'] = (
	_,
	{ spaceKey },
	{ network },
) => {
	return network
		.cfetch(`/wiki/rest/experimental/relation/user/current/favourite/toSpace/${spaceKey}`, {
			method: 'PUT',
		})
		.then(
			/* onFulfilled */ () => ({ spaceKey }),
			/* onRejected */ (reason) => {
				if (reason instanceof network.BadStatusError) {
					// TODO FIXME `false` does not exactly represent `ExperimentalFavouriteSpaceType`, so
					// this code branch is violating GraphQL schema definitions
					return false as any as ExperimentalFavouriteSpaceType;
				}

				throw reason;
			},
		);
};
